import { Box, Paper, Grid, Typography } from "@mui/material";

export default function EventsHeader() {

    return <>
        <Box sx={{ width: '100%' }} component={Paper}>

            <Grid container rowSpacing={4}>

                <Grid size={{ xs: 12 }}></Grid>

                <Grid size={{ xs: 12 }} sx={{ marginLeft: '2%' }}>
                    <Typography variant='h4'>
                        Application for CPD Approval
                    </Typography>
                </Grid>

                <Grid size={{ xs: 12 }} sx={{ marginLeft: '2%', marginRight: '2%' }}>
                    <Typography variant='h5'>
                        Accredited Continued Education (CE) Activity
                    </Typography>
                </Grid>

                <Grid size={{ xs: 12 }} sx={{ marginLeft: '2%', marginRight: '2%', marginBottom: '2%' }}>
                    <Typography variant='subtitle1'>
                        <b>Important Instructions:</b>
                    </Typography>

                    <ul>
                        <li>Please ensure you carefully review the guidelines provided before completing this form</li>
                        <li><b>Complete ALL sections</b> of this application form</li>
                    </ul>

                    <Typography variant='subtitle1'>
                        <b>Supporting Documentation:</b>
                    </Typography>

                    <Typography variant='subtitle1'>
                        To ensure your application is processed smoothly,
                    </Typography>

                    <ul>
                        <li>All mandatory supporting documentation must be submitted with your application</li>
                    </ul>

                    <Typography variant='subtitle1'>
                        <b>Guidelines</b>
                    </Typography>

                    <Typography variant='subtitle1'>
                        <span>Guidelines for RCSI Surgery / Emergency Medicine / Medicine - </span>
                        <a target="_blank" href="https://www.rcsi.com/surgery/practice/professional-competence-scheme/cpd-recognition-and-approval" rel="noreferrer">
                            click HERE
                        </a>.
                        <br></br>
                        <span>Guidelines for Faculty of Radiologists - </span>
                        <a target="_blank" href="https://www.radiology.ie/pcs/apply-for-cpd-external-credits1" rel="noreferrer">
                            click HERE
                        </a>.
                        <br></br>
                        <span>Guidelines for Sports & Exercise Medicine - </span>
                        <a target="_blank" href="https://fsem.ie/events/cpd-accreditation-application" rel="noreferrer">
                            click HERE
                        </a>.
                    </Typography>
                </Grid>

            </Grid>
        </Box>
    </>
}
